module.exports = __webpack_public_path__ + "img/file-storage-1.5f64d6de.svg";